import { render, staticRenderFns } from "./mrp-outstanding-sales-order-detail.vue?vue&type=template&id=9d835920"
import script from "./mrp-outstanding-sales-order-detail.vue?vue&type=script&lang=js"
export * from "./mrp-outstanding-sales-order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports